<template>
  <div class="card-wrapper">
    <div class="card" :class="{ 'is-flipped': !front }">
      <div class="card-content front">
        <img
          v-if="imgsrc && pictureHint"
          :src="imgsrc"
          alt="visual representation of this card"
          class="cardimg"
          @error="replaceByDefault"
        />
        <h3 class="cardTitle" style="display: flex;">
          <i
            class="fas fa-volume-down pointer main-playbtn"
            @click="playSound(card.front_word.sound.url, 'word', $event)"
            v-if="card.front_word && card.front_word.sound && !wordAudioLoading"
            type="sound"
            :class="{ 'animated heartBeat disableClick': wordAudioClicked }"
          />
          <i
            class="fas fa-circle-notch fa-spin main-playbtn"
            v-if="card.front_word && card.front_word.sound && wordAudioLoading"
          />
          <span class="article" style="height: 100%;" :class="articleClass">
            {{ article.text }}
          </span>
          <span class="word" v-if="card.front_word && card.front_word.word">
            <i class="fas fa-circle" :class="wordClass" v-if="!articleHint"></i>
            {{ card.front_word.word }}
            <span v-if="plural">, {{ plural }}</span>
          </span>
        </h3>
        <h5
          class="cardTitle cardExtra cardExtra-small"
          v-if="kasusObjekt !== ''"
          :class="{
            Akkusativ: kasusObjekt == 'Akkusativ',
            Dativ: kasusObjekt == 'Dativ'
          }"
        >
          ({{ kasusObjekt }})
        </h5>
        <h5 class="cardTitle cardExtra">{{ perfekt }}</h5>
        <h5 class="cardTitle cardExtra">{{ praeposition }}</h5>
        <p class="cardSubTitle" v-if="card.front_sentence">
          <i
            class="fas fa-volume-down pointer sentence-play"
            @click="
              playSound(card.front_sentence.sound.url, 'sentence', $event)
            "
            v-if="
              card.front_sentence &&
                card.front_sentence.sentence &&
                card.front_sentence.sound &&
                card.front_sentence.sound.url &&
                !sentenceAudioLoading
            "
            type="sound"
            :class="{ 'animated heartBeat disableClick': sentenceAudioClicked }"
          />
          <i
            v-if="
              front &&
                card.front_sentence &&
                card.front_sentence.sentence &&
                card.front_sentence.sound &&
                card.front_sentence.sound.url &&
                sentenceAudioLoading
            "
            class="fas fa-circle-notch fa-spin sentence-play"
          />
          <span
            class="sentences-wrapper"
            v-if="card.front_sentence && card.front_sentence.sentence"
          >
            <span
              v-for="(sentence, index) in parseSentence(
                card.front_sentence.sentence
              )"
              :key="`font-sentence${index}`"
              class="sentences"
            >
              <span>
                <i class="fas fa-user-circle" v-if="index % 2 === 0"></i>
                <i class="far fa-user-circle" v-else></i>
              </span>
              <span style="padding-left: 10px;">{{ sentence }}</span>
            </span>
          </span>
        </p>
      </div>
      <div
        class="card-content back"
        style="text-align: center;"
        v-if="card.back_word && card.back_word.word"
      >
        <img
          v-if="imgsrc && pictureHint"
          :src="imgsrc"
          class="cardimg"
          @error="replaceByDefault"
        />
        <h3 class="cardTitle" v-if="card.back_word && card.back_word.word">
          {{ card.back_word.word }}
        </h3>
        <template v-if="card.back_sentence && card.back_sentence.sentence">
          <p
            class="cardSubTitle sentences"
            v-for="(sentence, index) in parseSentence(
              card.back_sentence.sentence
            )"
            :key="`back-sentence-${index}`"
            style="margin:0"
          >
            <span>
              <i class="fas fa-user-circle" v-if="index % 2 === 0"></i>
              <i class="far fa-user-circle" v-else></i>
            </span>
            <span style="padding-left: 10px;text-align:left">{{
              sentence
            }}</span>
          </p>
          <!-- 
              disable pseudo translation temporaly
          <hr />
          <p
            style="color: #5a5a5a;text-align: left;"
            v-if="pseudoTranslation.length > 0"
          >
            {{ $t("pseudo translation") }}
          </p>
          <p
            class="cardSubTitle sentences"
            v-for="(sentence, index) in pseudoTranslation"
            :key="`pseduo-translation-${index}`"
            style="margin:0"
          >
            <span>
              <i class="fas fa-user-circle" v-if="index % 2 === 0"></i>
              <i class="far fa-user-circle" v-else></i>
            </span>
            <span style="padding-left: 10px;text-align:left">{{
              sentence
            }}</span>
          </p>
          -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "SwipeCard",
  props: {
    card: {
      type: Object,
      required: true
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // front: true,
      wordAudioClicked: false,
      sentenceAudioClicked: false,
      wordAudioLoading: false,
      sentenceAudioLoading: false
    };
  },
  computed: {
    ...mapState("setting", ["configurations"]),
    front() {
      if (this.card.front != undefined) {
        return this.card.front;
      }
      return true;
    },
    pseudoTranslation() {
      if (
        this.card.pseudo_translation_sentences &&
        this.card.pseudo_translation_sentences.length > 0
      ) {
        return this.parseSentence(
          this.card.pseudo_translation_sentences[0].translated
        );
      }
      return [];
    },
    articleColorHint() {
      return this.configurations.articleColorHint;
    },
    articleHint() {
      return this.configurations.articleHint;
    },
    pictureHint() {
      return this.configurations.pictureHint;
    },
    pluralHint() {
      return this.configurations.pluralHint;
    },
    praepositionHint() {
      return this.configurations.praepositionHint;
    },
    kasusObjektHint() {
      return this.configurations.kasusObjektHint;
    },
    perfektHint() {
      return this.configurations.perfektHint;
    },
    wordClass() {
      if (this.articleHint) {
        return {};
      }
      return this.articleColorHint && this.article.color
        ? `${this.article.color}`
        : "no-article";
    },
    articleClass() {
      return this.getArticleClass();
    },
    imgsrc() {
      const { card } = this;
      return card?.image ? `${this.$b2_url}/${card?.image}` : "";
    },
    plural() {
      if (this.pluralHint) {
        const { front_word } = this.card;
        if (front_word) {
          const { details } = front_word;
          if (details && details.plural) {
            return details.plural;
          }
        }
      }
      return "";
    },
    kasusObjekt() {
      if (!this.kasusObjektHint) {
        return "";
      }
      const { front_word } = this.card;
      if (front_word) {
        const { details } = front_word;
        let kasus_objekt =
          details != null && details.kasus_objekt
            ? details.kasus_objekt.trim()
            : "";
        if (kasus_objekt == "Akk") {
          return "Akkusativ";
        } else if (kasus_objekt === "Dat") {
          return "Dativ";
        }
      }
      return "";
    },
    praeposition() {
      if (this.praepositionHint) {
        const { front_word } = this.card;
        if (front_word) {
          const { details } = front_word;
          let praeposition =
            details != null && details.praeposition ? details.praeposition : "";
          return `${praeposition.split(",").join(" / ")}`;
        }
      }
      return "";
    },
    perfekt() {
      if (this.perfektHint) {
        const { front_word } = this.card;
        if (front_word) {
          const { details } = front_word;
          const partizip =
            details != null && details.hilfsverb_perfekt
              ? details.partizip_II
              : "";
          const hilfsverb_perfekt =
            details != null && details.hilfsverb_perfekt
              ? details.hilfsverb_perfekt
              : "";
          return `${hilfsverb_perfekt} ${partizip}`;
        }
      }
      return "";
    },
    article() {
      let res = { text: "", color: "" };
      const { front_word } = this.card;
      if (front_word) {
        const { details } = front_word;
        const article =
          details != null && details.artikel ? details.artikel : "";
        if (article === "m") {
          res = { text: "der", color: "blue" };
        } else if (article === "f") {
          res = { text: "die", color: "red" };
        } else if (article === "n") {
          res = { text: "das", color: "green" };
        }
        const articles = article.split(",");
        if (articles.length > 1) {
          const multiArticles = articles.reduce((accu, item, index) => {
            if (item === "m") {
              accu += "der ";
            } else if (item === "f") {
              accu += "die ";
            } else if (item === "n") {
              accu += "das ";
            }
            if (index != articles.length - 1) {
              accu += "/ ";
            }
            return accu;
          }, "");
          res = { text: multiArticles, color: "grey" };
        }
        if (!this.articleHint) {
          res.text = "";
        }
      }
      return res;
    }
  },
  methods: {
    ...mapActions("vokabel", ["addToFavBox", "fuckOff"]),
    replaceByDefault(e) {
      e.target.style.display = "none";
    },
    handleFuckOff() {
      this.fuckOff({
        wordId: this.card.front_word.id,
        boxId: this.$route.params.id
      });
    },
    clickAddToFavBox() {
      const { id } = this.card.front_word;
      this.addToFavBox({ id });
    },
    getArticleClass() {
      let classKey = this.articleColorHint
        ? `${this.article.color}-underline`
        : "";
      return {
        [classKey]: true
      };
    },
    parseSentence(sentence) {
      if (sentence || sentence != null || sentence != "") {
        return sentence
          .trim()
          .split("- ")
          .filter(i => i != "");
      }
      return [];
    },

    playSound(sound, soundType, e) {
      if (e) {
        e.stopPropagation();
      }
      // workaroundf for now... to show loading circle
      // since html5 audio loading doesnt work on mobile
      // dont play the sound twice
      if (this.wordAudioClicked && this.sentenceAudioClicked) {
        return;
      }
      if (soundType == "word") {
        this.wordAudioLoading = true;
        setTimeout(() => {
          this.wordAudioLoading = false;
          this.wordAudioClicked = true;
        }, 2000);
        this.timer = setTimeout(() => {
          this.wordAudioClicked = false;
        }, 5000);
      } else {
        this.sentenceAudioLoading = true;
        setTimeout(() => {
          this.sentenceAudioLoading = false;
          this.sentenceAudioClicked = true;
        }, 2000);
        this.timer = setTimeout(() => {
          this.sentenceAudioClicked = false;
        }, 5000);
      }
      if (sound) {
        let audio = new Audio(`${this.$b2_initial_worter}/${sound}.mp3`);
        audio.play();
      }
    }
  },
  created() {
    if (this.isCurrent && this.configurations.autoPlayWordSound) {
      this.playSound(this.card.front_word.sound.url, "word");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles.scss";

$cardsTotal: 3;
$cardsWidth: 300px;
$cardsPositionOffset: 55vh * 0.06;
$cardsScaleOffset: 0.08;
$defaultTranslation: $cardsPositionOffset * $cardsTotal;
$defaultScale: 1 - ($cardsScaleOffset * $cardsTotal);
$fs-card-title: 1.6em;
$fs-card-subtitle: 1em;

.card-wrapper {
  height: calc(100vh - 175px);
  margin-bottom: 30px;
  display: flex;
}
.card {
  @include flex-center();
  margin: 0 auto;
  border-radius: 15px;
  display: flex;
  font-size: $fs-h2;
  font-weight: $fw-bold;
  color: $c-white;
  background-image: linear-gradient(-180deg, #fff 2%, #fff 100%);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
  height: calc(100vh - 155px);
  max-height: 500px;
  width: 350px;
  margin-bottom: 15px;
  transition: transform 1s ease-in;
  transform-style: preserve-3d;
  align-self: center;

  .cardTitle {
    text-align: left;
    margin: 0 0 15px;
    font-size: $fs-card-title;
    color: #585858;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
    .article {
      display: inline-block;
    }
    .word {
      display: inline-block;
      width: 75%;
      margin-left: 7px;
      margin-right: 7px;
      display: flex;
      align-self: center;
    }
  }

  .cardSubTitle {
    font-size: 0.9em;
    color: #333;
    @include padding-left-right(5px);
    font-family: varela;
    display: flex;
  }
}

.card.is-flipped {
  transform: rotateY(180deg);
}

.card-content {
  position: absolute;
  transition: transform 1s ease-in;
  backface-visibility: hidden;

  display: flex;
  align-self: center;
  flex-direction: column;
  width: 85%;
  position: absolute;
  text-align: left;
}

.back {
  transform: rotateY(-180deg);
  background-color: white;
  height: 100%;
  justify-content: center;
}

.red-underline {
  border-bottom: 5px solid $action-red;
  margin-bottom: -5px;
}
.blue-underline {
  border-bottom: 5px solid $action-blue;
  margin-bottom: -5px;
}
.green-underline {
  border-bottom: 5px solid $action-green;
  margin-bottom: -5px;
}
.sentence-play {
  display: flex;
  width: 10px;
  margin-top: 5px;
  margin-right: 5px;
  height: 10px;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.main-playbtn {
  display: flex;
  justify-self: center;
  align-items: center;
  width: 26px;
  margin-right: 5px;
}

.cardExtra {
  font-size: 1.4rem !important;
  margin-top: -10px !important;
}
.cardExtra-small {
  font-size: 1.1rem !important;
}
.Akkusativ {
  color: red !important;
}
.Dativ {
  color: green !important;
}
.cardimg {
  width: 50%;
  height: auto;
  margin: 10px auto;
}
.disableClick {
  pointer-events: none;
}
.sentences {
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  color: #333;
}

.btns-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  max-width: 300px;
  margin: auto;
  margin-top: 5px;
  z-index: 1000;
  margin-bottom: 20px;
}
.large-circle-btn {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  i.green {
    color: $action-green;
    font-size: 1.2rem;
  }
  i.red {
    color: $action-red;
    font-size: 1.2rem;
  }
  i.yellow {
    color: $action-yellow;
    font-size: 1rem;
    transform: rotateY(180deg);
  }
  i.blue {
    color: $action-blue;
    font-size: 1rem;
  }
}
.small-circle-btn {
  height: 35px;
  width: 35px;
}

.word {
  .red,
  .blue,
  .green {
    display: flex;
    font-size: 1rem;
    justify-self: center;
    align-self: center;
    margin-right: 5px;
  }
  .red {
    color: $action-red;
  }
  .blue {
    color: $action-blue;
  }
  .green {
    color: $action-green;
  }

  .no-article {
    display: none;
  }
}
</style>
